import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import Select from '../../../components/ui/Select';
import { userRoleService } from '../../../services/userRoleService';
import { mapAssignableRoleOptions } from '../syncUserRoles';

const ASSIGNABLE_ROLE_FALLBACK = [
  { value: 'administrator', label: 'Administrateur' },
  { value: 'agent_administratif', label: 'Agent administratif' },
  { value: 'production_supplier', label: 'Fournisseur de Production' },
  { value: 'dentist_client', label: 'Client Dentiste' },
  { value: 'dentist_supplier', label: 'Dentiste Fournisseur' },
  { value: 'distributor', label: 'Distributeur' },
];

const UserRolesMultiSelect = ({
  value = [],
  onChange,
  disabled = false,
  label = 'Rôles',
  placeholder = 'Sélectionnez un ou plusieurs rôles',
  className = '',
  required = false,
  error,
  description = 'Vous pouvez affecter plusieurs rôles (ex. Opérateur 3D et Opérateur finition).',
}) => {
  const [roleOptions, setRoleOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        const roles = await userRoleService.getAllRoles();
        const mapped = mapAssignableRoleOptions(roles);
        if (!cancelled) {
          setRoleOptions(mapped.length > 0 ? mapped : ASSIGNABLE_ROLE_FALLBACK);
          if (!mapped.length && roles?.length) {
            toast.warning('Aucun rôle assignable actif trouvé.');
          } else if (!mapped.length) {
            toast.warning('Liste des rôles indisponible — affichage des rôles par défaut.');
          }
        }
      } catch (err) {
        console.error('Erreur chargement rôles:', err);
        toast.error('Impossible de charger la liste des rôles.');
        if (!cancelled) setRoleOptions(ASSIGNABLE_ROLE_FALLBACK);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const selected = Array.isArray(value) ? value : value ? [value] : [];

  return (
    <Select
      label={label}
      options={roleOptions}
      value={selected}
      onChange={(next) => onChange?.(Array.isArray(next) ? next : [])}
      multiple
      searchable
      clearable={false}
      disabled={disabled || loading}
      loading={loading}
      placeholder={placeholder}
      className={className}
      required={required}
      error={error}
      description={description}
    />
  );
};

export default UserRolesMultiSelect;
